import axios from 'axios';
import { union, isEmpty } from 'lodash';
export default {
	state: () => ({
		enrollmentType: 'normal',
		campaignId: null,
		totalFormSteps: 0,
		editable: true,
		showPopup: false,
		doNotShowPopupAgain: false,
		stepsFinished: 0,
		enrollmentFormId: null,
		apiUrlEnrollment: '/api/enrollments/',
		dataIsNotSaved: false,
		unsavedStep: 0,
		currentPageId: 0,
		formStatus: '',
		/**
		 * @deprecated use global spinner from `globalAssets` store
		 */
		spinnerIsShown: false,
		selectedEnrollmentProducts: [],
		isOCform: false,
		activeStep: 0,
		selectedFromNavStep: 0,
		draftStatus: 'Draft',
		emrDraftStatus: 'EmrDraft',
		lubricantsData: {},
		shouldResetLubricantModal: false,
		matchingProductsData: {},
		optionalFieldLabel: 'optional',
		summaryCheckoxLabel: 'yes',
		userProfile: {},
		hspInformationPayload: {
			campaignId: null,
			guestFacilityId: "",
			type: "",
			subType: ''
		},
		experianAutocompleteData: {},
		trackingData: {},
		hcpFacilityInfo: {
			facilityName: '',
			facilityAddress: '',
			facilityPhone: '',
			firstName: '',
			lastName: '',
			email: '',
			npi: '',
			confirmEmail: '',
			providerName: ''
		},
		subType: '',
		dashboardUrl: '',
		createdBy: '',
		createdByDisplayName: '',
		isICQuickForm: false,
		guestSubmitPopup: {
			description: "",
			headline: "",
			submitAndCreateAccountButtonText: "",
			submitAsGuestButtonText: "",
		},
		documents: [],
		isDocumentsValid: true,
		stomaType: null,
	}),
	getters: {
		getEditable: (state) => {
			return state.editable
		},
		getEnrollmentType: (state) => {
			return state.enrollmentType
		},
		getCampaignId: (state) => {
			return state.campaignId
		},
		getTotalFormSteps: (state) => {
			return state.totalFormSteps
		},
		getStepsFinished: (state) => {
			return state.stepsFinished;
		},
		getShowPopup: (state) => {
			return state.showPopup;
		},
		getDoNotShowPopupAgain: (state) => {
			return state.doNotShowPopupAgain;
		},
		getEnrollmentFormId: (state) => {
			return state.enrollmentFormId;
		},
		getApiUrlEnrollment: (state) => {
			return state.apiUrlEnrollment;
		},
		getApiUrl: (state) => (stepUrl) => {
			return state.enrollmentFormId === null ? `${state.apiUrlEnrollment}${stepUrl}` : `${state.apiUrlEnrollment}${stepUrl}?id=${state.enrollmentFormId}`;
		},
		getCurrentPageId: (state) => {
			return state.currentPageId;
		},
		getPrefilledData: (state) => {
			return state.prefilledData;
		},
		getDataIsNotSaved: (state) => {
			return state.dataIsNotSaved;
		},
		getUnsavedStep: (state) => {
			return state.unsavedStep;
		},
		getFormStatus: (state) => {
			return state.formStatus;
		},
		getTrackingData: (state) => {
			return state.trackingData;
		},
		getIsFormSubmitted: (state) => {
			return state.formStatus === 'Submitted' || state.formStatus === 'SubmittedUnsigned';
		},
		/**
		 * @deprecated use global spinner from `globalAssets` store
		 */
		getShowSpinner: (state) => {
			return state.spinnerIsShown;
		},
		getSelectedEnrollmentProducts: (state) => {
			return state.selectedEnrollmentProducts;
		},
		getIsOCform: (state) => {
			return state.isOCform;
		},
		getActiveStep: (state) => {
			return state.activeStep;
		},
		getSelectedFromNavStep: (state) => {
			return state.selectedFromNavStep;
		},
		getEmrDraftStatus: (state) => {
			return state.emrDraftStatus;
		},
		getDraftStatus: (state) => {
			return state.draftStatus;
		},
		getPreviousStep: (state) => {
			return state.previousStep;
		},
		getLubricantsData: (state) => {
			return state.lubricantsData;
		},
		getLubricantModalState: (state) => {
			return state.shouldResetLubricantModal;
		},
		getSummaryCheckoxLabel: (state) => {
			return state.summaryCheckoxLabel;
		},
		getOptionalFieldLabel: (state) => {
			return state.optionalFieldLabel;
		},
		getUserProfile: (state) => {
			return state.userProfile;
		},
		getMatchingProductsData: (state) => {
			return state.matchingProductsData;
		},
		getHspInformationPayload: (state) => {
			return state.hspInformationPayload;
		},
		getHcpFacilityInfo: (state) => {
			return state.hcpFacilityInfo;
		},
		getSubType: (state) => {
			return state.subType;
		},
		getDashboardUrl: (state) => {
			return state.dashboardUrl;
		},
		getCreatedBy: (state) => {
			return {
				createdBy: state.createdBy,
				createdByDisplayName: state.createdByDisplayName
			};
		},

		getIsICQuickForm: (state) => {
			return state.subType === "CareAdvisor" && !state.isOCform
		},
		getGuestSubmitPopup: (state) => {
			return state.guestSubmitPopup
		},

		getDocuments: (state) => {
			return state.documents
		},

		getIsDocumentsValid: (state) => {
			return state.isDocumentsValid
		},

		getStomaType: (state) => {
			return state.stomaType
		},

		getExperianAutocompleteData: (state) => {
			return state.experianAutocompleteData;
		},

	},
	mutations: {
		setEditable: (state, editable) => {
			state.editable = editable
		},
		setCampaignId: (state, campaignId) => {
			state.campaignId = campaignId
		},
		setEnrollmentType: (state, type) => {
			state.enrollmentType = type;
		},
		setTotalFormSteps: (state, totalFormSteps) => {
			state.totalFormSteps = totalFormSteps;
		},
		setApiUrlEnrollment: (state, apiUrl) => {
			state.apiUrlEnrollment = apiUrl;
		},
		setShowPopup: (state, showPopup) => {
			state.showPopup = showPopup;
		},
		setCurrentPageId: (state, currentPageId) => {
			state.currentPageId = currentPageId;
		},
		setDoNotShowPopupAgain: (state, doNotShowPopupAgain) => {
			state.doNotShowPopupAgain = doNotShowPopupAgain;
		},
		setStepsFinished: (state, stepsFinished) => {
			state.stepsFinished = stepsFinished;
		},
		setEnrollmentFormId: (state, enrollmentFormId) => {
			state.enrollmentFormId = enrollmentFormId;
		},
		setTrackingData: (state, trackingData) => {
			state.trackingData = trackingData;
		},
		setPrefilledData: (state, prefilledData) => {
			state.prefilledData = Object.assign({}, prefilledData);
		},
		setDataIsNotSaved: (state, dataIsNotSaved) => {
			state.dataIsNotSaved = dataIsNotSaved;
		},
		setUnsavedStep: (state, unsavedStep) => {
			state.unsavedStep = unsavedStep;
		},
		setFormStatus: (state, formStatus) => {
			state.formStatus = formStatus;
		},
		/**
		 * @deprecated use global spinner from `globalAssets` store
		 */
		setSpinnerIsShown: (state, isShown) => {
			state.spinnerIsShown = isShown;
		},
		setSelectedEnrollmentProducts: (state, products) => {
			state.selectedEnrollmentProducts = products;
		},
		setIsOCform: (state, isOCform) => {
			state.isOCform = isOCform;
		},
		setActiveStep: (state, step) => {
			state.activeStep = step;
		},
		setSelectedFromNavStep: (state, step) => {
			state.selectedFromNavStep = step;
		},
		setPreviousStep: (state, step) => {
			state.previousStep = step;
		},
		setLubricantsData: (state, data) => {
			state.lubricantsData = Object.assign({}, data);
		},
		setLubricantModalState: (state, data) => {
			state.shouldResetLubricantModal = data;
		},
		setMatchingProductsData: (state, data) => {
			state.matchingProductsData = Object.assign({}, data);
		},
		setUserProfile: (state, data) => {
			state.userProfile = data;
		},
		setHspInformationPayload: (state, data) => {
			state.hspInformationPayload = { ...data };
		},

		setOptionalFieldLabel: (state, label) => {
			state.optionalFieldLabel = label;
		},
		setHcpFacilityInfo: (state, data) => {
			state.hcpFacilityInfo = {...data};
		},
		setSubType: (state, type) => {
			state.subType = type;
		},
		setDashboardUrl: (state, url) => {
			state.dashboardUrl = url;
		},
		setCreatedBy: (state, data) => {
			state.createdBy = data.createdBy;
			state.createdByDisplayName = data.createdByDisplayName;
		},

		setGuestSubmitPopup: (state, data) => {
			state.guestSubmitPopup = {...data}
		},

		setDocuments: (state, docs) => {
			if ( typeof (docs) === 'object' && !isEmpty(docs) ) {
				state.documents = union(state.documents, docs)
			} else {
				state.documents.push(docs)
			}
		},

		setIsDocumentsValid: (state, isValid) => {
			state.isDocumentsValid = isValid
		},

		setStomaType: (state, type) => {
			state.stomaType = type
		},

		setSummaryCheckoxLabel: (state, label) => {
			state.summaryCheckoxLabel = label
		},
		setExperianAutocompleteData: (state, payload) => {
			state.experianAutocompleteData = {...state.experianAutocompleteData, ...payload};
		},
	},
	actions: {
		/**
		 * @deprecated use global spinner from `globalAssets` store
		 */
		showSpinner: ({ commit }) => {
			commit('setSpinnerIsShown', true);
		},
		/**
		 * @deprecated use global spinner from `globalAssets` store
		 */
		hideSpinner: ({ commit }) => {
			commit('setSpinnerIsShown', false);
		},
		fetchUserData: function ({ commit }) {
			axios.get('/api/myhcpprofile/profile')
				.then(response => {
					commit('setUserProfile', response.data);
				})
				.catch(error => {
					console.warn(error);
				});
		},
		activateVariantsSelect: async ({ commit }, selectedVariationCode) => {
			try {
				let response = await axios.get(getVariantsApiUrl + selectedVariationCode);
				if (response.data) {
					commit('setCompatibleItems', [...response.data.compatibleItems]);
				}
			} catch (err) {
				console.error(err);
			}
		}
	}
};
